import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classes from './Recordings.module.scss';

class Recordings extends React.Component {
  handleClick = (event) => {
    event.stopPropagation();
    window.open(this.props.recordingsUrl, '_blank');
  };

  render() {
    return (
      <div className={classes.recordingsContainer}>
        <div className={classes.recordingsLabel}>
          <FormattedMessage
            id="components.activityFeed.recordingsLabel"
            description="Recordings label"
            defaultMessage="Recordings"
          />
        </div>
        <hr />
        <button className={classes.recordingsButton} onClick={this.handleClick} data-testid="viewRecordings">
          <FormattedMessage
            id="components.activityFeed.recordingsButton"
            description="Recordings Button"
            defaultMessage="View Recordings"
          />
        </button>
      </div>
    );
  }
}

export default Recordings;

Recordings.propTypes = {
  recordingsUrl: PT.string.isRequired
};
